// Re-export stub — Dashboard has moved to src/Dashboard/Dashboard.jsx
// This file preserves backward compatibility for existing imports.
export { default as SystemIdContext } from "../SystemIdContext";
export { default } from "../Dashboard";
